@use "ui/styles/colors";
@use "ui/styles/sizes";
@use "ui/styles/effects";
@use "ui/styles/fonts";
@use "ui/styles/zindex";

.content {
    background: var(--tooltip-background-color, colors.$gray90);
    color: var(--tooltip-text-color, colors.$white);
    border-radius: effects.$borderRadiusS;
    padding: sizes.$s4 sizes.$s5;
    font-size: fonts.$mid;
    box-shadow: 0px 2px 8px 0px effects.$shadowColor;
    z-index: zindex.$tooltip;
    max-width: var(--tooltip-max-width, 250px);
    word-wrap: break-word;
    ul,
    ol {
        margin: 0;
        padding-left: sizes.$s6;
        padding-top: sizes.$s3;
        padding-bottom: sizes.$s3;
    }
    // Use CSS custom property for transform origin
    transform-origin: var(--radix-tooltip-content-transform-origin);
    // Animation properties for enter/exit
    animation-duration: 200ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);

    &[data-state="delayed-open"] {
        animation-name: fadeInAndScale;
    }

    &[data-state="instant-open"] {
        animation-name: fadeInAndScale;
    }

    &[data-state="closed"] {
        animation-name: fadeOutAndScale;
    }

    // Direction-specific animations
    &[data-side="top"] {
        animation-name: slideDownAndFade;
    }

    &[data-side="right"] {
        animation-name: slideLeftAndFade;
    }

    &[data-side="bottom"] {
        animation-name: slideUpAndFade;
    }

    &[data-side="left"] {
        animation-name: slideRightAndFade;
    }
}

.arrow {
    fill: var(--tooltip-background-color, colors.$gray90);
}

// Animation keyframes
@keyframes fadeInAndScale {
    from {
        opacity: 0;
        transform: scale(0.96);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes fadeOutAndScale {
    from {
        opacity: 1;
        transform: scale(1);
    }

    to {
        opacity: 0;
        transform: scale(0.96);
    }
}

@keyframes slideUpAndFade {
    from {
        opacity: 0;
        transform: translateY(2px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes slideRightAndFade {
    from {
        opacity: 0;
        transform: translateX(-2px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}

@keyframes slideDownAndFade {
    from {
        opacity: 0;
        transform: translateY(-2px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes slideLeftAndFade {
    from {
        opacity: 0;
        transform: translateX(2px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}
